module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/品质中心组件1.7460c425.png";